import React from "react";
import { IListingDetailGroup } from "../../lib/Listing";

export enum EListingDetailsLayout {
  groupRows = "groupRows",
  groupColumns = "groupColumns",
  groupNone = "groupNone",
}

export interface IListingDetailsProps {
  title?: string;
  titleClassName?: string;
  detailGroups: IListingDetailGroup[];
  layout?: EListingDetailsLayout;
  className?: string;
}

export const ListingDetails: React.FC<IListingDetailsProps> = ({
  title,
  titleClassName = "",
  detailGroups,
  layout = EListingDetailsLayout.groupRows,
  className,
}) => {
  let layoutSpecs = {
    parentList: "",
    parentListItem: "",
    groupList: "",
    groupHeader: "",
    details: "",
  };

  switch (layout) {
    case EListingDetailsLayout.groupRows:
      layoutSpecs = {
        ...layoutSpecs,
        groupList:
          "border-b grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
        groupHeader: "border my-8",
      };
      break;
    case EListingDetailsLayout.groupColumns:
      layoutSpecs = {
        ...layoutSpecs,
        parentList: "md:columns-2",
        parentListItem: "break-inside-avoid",
        groupList: "flex flex-col gap-3",
        groupHeader: "italic my-3",
        details: "inline capitalize mr-2",
      };
      break;
    case EListingDetailsLayout.groupNone:
      layoutSpecs = {
        ...layoutSpecs,
        parentList:
          "grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
      };
      break;
  }

  return (
    <div className={`listing-details ${className}`}>
      {title && <h2 className={`text-h2-text ${titleClassName}`}>{title}</h2>}
      <ul className={`list-none max-w-screen-xl ${layoutSpecs.parentList}`}>
        {detailGroups.map((group, index) => {
          if (layout != EListingDetailsLayout.groupNone) {
            return (
              <li className={layoutSpecs.parentListItem} key={index}>
                {group.name && (
                  <h2
                    className={`inline-block px-2 py-1 ${layoutSpecs.groupHeader}`}
                  >
                    {group.name}
                  </h2>
                )}
                <ul className={`list-none px-3 pb-7 ${layoutSpecs.groupList}`}>
                  {group.details.map((detail, index) => {
                    return (
                      <li key={index}>
                        <div
                          className={`uppercase font-semibold pb-0.5 ${layoutSpecs.details}`}
                        >
                          {detail.label}
                        </div>
                        {detail.value && (
                          <div className={layoutSpecs.details}>
                            {typeof detail.value == "string" && detail.value.split("\n").map((value, index) => (
                              <>
                                {index > 0 && <br />}
                                {value}
                              </>
                            ))}
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          } else {
            return (
              <>
                {group.details.map((detail, index) => {
                  return (
                    <li className="pb-3" key={index}>
                      <div className="uppercase font-semibold pb-0.5">
                        {detail.label}
                      </div>
                      {detail.value && (
                        <div>
                          {typeof detail.value == "string" && detail.value.split("\n").map((value, index) => (
                            <>
                              {index > 0 && <br />}
                              {value}
                            </>
                          ))}
                        </div>
                      )}
                    </li>
                  );
                })}
              </>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default ListingDetails;
